import { createContext, useContext } from 'react';

/**
 * "Ver como o cliente" (ADR 0223): a equipe vê as telas do cliente só para ler. Dentro deste
 * contexto, os botões que mudam algo (pagar, começar, publicar, cancelar) não aparecem.
 */
export const ReadOnlyView = createContext(false);

export function useReadOnly() {
  return useContext(ReadOnlyView);
}
